var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_641_1076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.64272 1.07059H2.57129C2.61058 1.07059 2.64272 1.03845 2.64272 0.999163V1.07059H5.357V0.999163C5.357 1.03845 5.38915 1.07059 5.42843 1.07059H5.357V1.71345H5.99986V0.999163C5.99986 0.683984 5.74361 0.427734 5.42843 0.427734H2.57129C2.25611 0.427734 1.99986 0.683984 1.99986 0.999163V1.71345H2.64272V1.07059ZM7.14272 1.71345H0.857003C0.698968 1.71345 0.571289 1.84113 0.571289 1.99916V2.28488C0.571289 2.32416 0.603432 2.35631 0.642718 2.35631H1.182L1.40254 7.02595C1.41683 7.33041 1.66861 7.57059 1.97308 7.57059H6.02665C6.332 7.57059 6.5829 7.33131 6.59718 7.02595L6.81772 2.35631H7.35701C7.39629 2.35631 7.42843 2.32416 7.42843 2.28488V1.99916C7.42843 1.84113 7.30076 1.71345 7.14272 1.71345ZM5.9579 6.92773H2.04183L1.82575 2.35631H6.17397L5.9579 6.92773Z",
    fillOpacity: 0.65
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_641_1076"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.7019d7002463e72009d19f281db3de56.svg";
export { ForwardRef as ReactComponent };